var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaypointIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.61295 1C4.40841 1 1 4.40845 1 8.61295C1 13.2466 6.16238 19.0025 7.985 20.8903C8.32984 21.2474 8.89607 21.2474 9.24091 20.8903C11.0635 19.0025 16.2259 13.2466 16.2259 8.61295C16.2259 4.40844 12.8175 1 8.61296 1H8.61295Z",
    stroke: "#5ACAD5",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61294 11.7684C10.5019 11.7684 12.0332 10.2371 12.0332 8.34811C12.0332 6.45912 10.5019 4.9278 8.61294 4.9278C6.72395 4.9278 5.19263 6.45912 5.19263 8.34811C5.19263 10.2371 6.72395 11.7684 8.61294 11.7684Z",
    stroke: "#5ACAD5",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaypointIcon);
export default __webpack_public_path__ + "static/media/waypoint-icon.19248715efac2ca1fbb984487f15cbcd.svg";
export { ForwardRef as ReactComponent };